import { Station } from '../types';

import { turfBounds } from 'shared/utils';

export const getStationsBounds = (stations: Station[]) => {
  const stationCoordinates = stations.reduce((acc, { coordinates }) => {
    acc.push([
      coordinates.longitude,
      coordinates.latitude
    ]);
    return acc;
  }, [] as number[][]);

  return turfBounds(stationCoordinates);
}